export const legacyStrings = {
  // Below are used to build legacy i18n object in Campaign repo. CC repo already passes in new i18n object.
  // customer-utils.js
  '{{name}} ({{number}})': _TL_('{{name}} ({{number}})'),
  // insertion-order-utils.js
  'No End Date': _TL_('No End Date'),
  Unlimited: _TL_('Unlimited'),
  // payment-utils.js
  'Prepaid ': _TL_('Prepaid '),
  Visa: _TL_('Visa'),
  MasterCard: _TL_('MasterCard'),
  'American Express': _TL_('American Express'),
  Discover: _TL_('Discover'),
  'Diners Club': _TL_('Diners Club'),
  JCB: _TL_('JCB'),
  'Carte Blanche': _TL_('Carte Blanche'),
  JAL: _TL_('JAL'),
  'Invoice (SAP)': _TL_('Invoice (SAP)'),
  PayPal: _TL_('PayPal'),
  'Bank transfer': _TL_('Bank transfer'),
  'Boleto Bancário: {{friendlyName}}': _TL_('Boleto Bancário: {{friendlyName}}'),
  'Check: {{friendlyName}}': _TL_('Check: {{friendlyName}}'),
  '{{cardType}} {{cardCategory}}****{{last4}} ({{country}})': _TL_('{{cardType}} {{cardCategory}}****{{last4}} ({{country}})'),
  'Expired {{date}}': _TL_('Expired {{date}}'),
  'Expires {{date}}': _TL_('Expires {{date}}'),
  '{{cardType}} {{cardCategory}}****{{last4}}': _TL_('{{cardType}} {{cardCategory}}****{{last4}}'),
  'On hold {{date}}': _TL_('On hold {{date}}'),
  'Payment method: {{id}}': _TL_('Payment method: {{id}}'),
  'Electronic funds transfer: {{friendlyName}}': _TL_('Electronic funds transfer: {{friendlyName}}'),
  'Bank transfer ({{country}})': _TL_('Bank transfer ({{country}})'),
  'PayPal: {{email}}': _TL_('PayPal: {{email}}'),
  'SAP: {{customerName}} ({{invoiceId}})': _TL_('SAP: {{customerName}} ({{invoiceId}})'),
  'SAP: {{invoiceId}}': _TL_('SAP: {{invoiceId}}'),
  'SEPA direct debit: {{friendlyName}}': _TL_('SEPA direct debit: {{friendlyName}}'),
  'Virtual Bank Account: {{friendlyName}}': _TL_('Virtual Bank Account: {{friendlyName}}'),
  'N/A': _TL_('N/A'),
  // tax-utils.js
  CPF: _TL_('CPF'),
  CNPJ: _TL_('CNPJ'),
  'GST IN': _TL_('GST IN'),
  PAN: _TL_('PAN'),
  VAT: _TL_('VAT'),
  'Australian Business Number': _TL_('Australian Business Number'),
  'NZ GST registration number': _TL_('NZ GST registration number'),
  'C.C.M.': _TL_('C.C.M.'),
  IE: _TL_('IE'),
  'GST/HST registration number or Business Number': _TL_('GST/HST registration number or Business Number'),
  'PST registration number': _TL_('PST registration number'),
  'QST registration number': _TL_('QST registration number'),
  'Legal Identifier Number': _TL_('Legal Identifier Number'),
  'NIT/Tax ID': _TL_('NIT/Tax ID'),
  'RUT Number': _TL_('RUT Number'),
  'TRN or VAT ID': _TL_('TRN or VAT ID'),
  'VAT ID': _TL_('VAT ID'),
  TIN: _TL_('TIN'),
  VKN: _TL_('VKN'),
  BIN: _TL_('BIN'),
  NPWP: _TL_('NPWP'),
  'VAT-TIN': _TL_('VAT-TIN'),
  'TIN or VAT ID': _TL_('TIN or VAT ID'),
  NIT: _TL_('NIT'),
  AAH: _TL_('AAH'),
  'NDS/KKS': _TL_('NDS/KKS'),
  RFC: _TL_('RFC'),
  'Tax identification number (PIB)': _TL_('Tax identification number (PIB)'),
  'Legal number': _TL_('Legal number'),
  CUIT: _TL_('CUIT'),
  VÖEN: _TL_('VÖEN'),
  IFU: _TL_('IFU'),
  'Tax ID': _TL_('Tax ID'),
  'n° TVA': _TL_('n° TVA'),
  JCT: _TL_('JCT'),
  SST: _TL_('SST'),
  TBC: _TL_('TBC'),
  FIN: _TL_('FIN'),
  'VAT Reg. No.': _TL_('VAT Reg. No.'),
  RIF: _TL_('RIF'),
  TPIN: _TL_('TPIN'),
  TRN: _TL_('TRN'),
  UIN: _TL_('UIN'),
  BRN: _TL_('BRN'),
  RUC: _TL_('RUC'),
  RUT: _TL_('RUT'),
  STRN: _TL_('STRN'),
  '(optional)': _TL_('(optional)'),
  '(State Tax ID, optional)': _TL_('(State Tax ID, optional)'),
  '(required)': _TL_('(required)'),
  '(required for all the entities)': _TL_('(required for all the entities)'),
  '(required for business customers)': _TL_('(required for business customers)'),
  '(required for VAT registered business customers)': _TL_('(required for VAT registered business customers)'),
  '(required for Value Added Tax/IVA registered customers)': _TL_('(required for Value Added Tax/IVA registered customers)'),
  '(required for IVA/VAT tax-payers)': _TL_('(required for IVA/VAT tax-payers)'),
};

export type LegacyStrings = typeof legacyStrings;
